// How stale is a request? The admin boards (ConsoleQuotations / ConsoleManaged /
// AdminConcierge / AdminTraderDetail) all age their cards through this module, so the
// thresholds live in exactly ONE place and can be retuned once the real distribution
// of waiting times is known. They are placeholders until then.
export const WARN_HOURS = 24;
export const OVERDUE_HOURS = 48;

// 'ok' | 'warn' | 'overdue'.
// Only a request still WAITING on someone ages — replied/closed ones never flag.
// An explicit response_deadline is a promise to the trader, so a passed deadline is
// overdue regardless of the hour count.
export function activityLevel({ last_activity_at, created_at, deadline, waiting = true }, now = Date.now()) {
  if (!waiting) return 'ok';
  if (deadline) {
    const d = new Date(deadline).getTime();
    if (Number.isFinite(d) && d < now) return 'overdue';
  }
  const t = new Date(last_activity_at || created_at || 0).getTime();
  if (!Number.isFinite(t) || t <= 0) return 'ok';
  const hours = (now - t) / 3600000;
  if (hours >= OVERDUE_HOURS) return 'overdue';
  if (hours >= WARN_HOURS) return 'warn';
  return 'ok';
}

// Has anything actually moved since submission? New rows start with
// last_activity_at == created_at, and a card with no movement shows only "Submitted".
export function hasActivity({ last_activity_at, created_at }) {
  if (!last_activity_at || !created_at) return false;
  return new Date(last_activity_at).getTime() - new Date(created_at).getTime() > 1000;
}

export function activityLabel(level, isAr) {
  if (level === 'overdue') return isAr ? 'متأخر' : 'Overdue';
  if (level === 'warn') return isAr ? 'ينتظر ردًا' : 'Waiting';
  return '';
}
